export const RESETTING_EMAIL = "RESETTING_EMAIL";
export const HOME_PAGE_REDIRECT = "/dashboard";
export const EMPLOYER_HOME_PAGE_REDIRECT = "/resume-benchmark/home";

export const AUTH_COOKIE = "auth";

export const ROLE = {
  CANDIDATE: "CANDIDATE_ROLE_ID",
  RECRUITER: "RECRUITER_ROLE_ID",
};
